import {
  ADD_DATA_CATEGORY,
  ADD_DATA_CATEGORY_FAILED,
  ADD_DATA_CATEGORY_SUCCESS,
  ADD_DATASET,
  ADD_DATASET_FAILED,
  ADD_DATASET_SUCCESS,

  UPDATING_DATA_CATEGORY,
  UPDATING_DATA_CATEGORY_COMPLETE,

  ADD_DATA_SUB_CATEGORY,
  ADD_DATA_SUB_CATEGORY_COMPLETE,

  FETCH_EXCEL_CATEGORIES,
  FETCH_EXCEL_CATEGORIES_COMPLETE,
  FETCH_EXCEL_INDICATIONS,
  FETCH_EXCEL_INDICATIONS_COMPLETE,
  FETCH_EXCEL_CHART_DATA,
  FETCH_EXCEL_CHART_DATA_COMPLETE,

  FETCH_EXCEL_YEARS,
  FETCH_EXCEL_YEARS_COMPLETE,

  FETCH_DATA_CATEGORIES,
  FETCH_DATA_CATEGORIES_COMPLETE,

  FETCH_SUB_DATA_CATEGORIES,
  FETCH_SUB_DATA_CATEGORIES_COMPLETE,

  FETCH_DATA_CATEGORY,
  FETCH_DATA_CATEGORY_COMPLETE,

  FETCH_DATASETS,
  FETCH_DATASETS_COMPLETE,

  FETCH_DATA_VALUES,
  FETCH_DATA_VALUES_COMPLETE,

  FETCH_TRENDING_CATEGORIES,
  FETCH_TRENDING_CATEGORIES_COMPLETE,
} from "./types";

export const initialState = {
  addingDataCategory: false,
  addingDataset: false,
  updatingCategory: false,
  addingSubCategory: false,

  excelCategories: [],
  excelIndications: [],
  excelChartData: null,
  excelYears: [],
  fetchingExcelData: false,

  dataCategories: [],
  fetchingDataCategories: false,

  subDataCategories: [],
  fetchingSubDataCategories: false,

  singleCategory: null,
  fetchingSingleCategory: false,

  dataSets: [],
  fetchingDataSets: false,

  dataValues: [],
  totalDataValues: 0,
  fetchingDataValues: false,

  trendingCategories: [],
  fetchingTrendingCategories: false,
};

export const dataReducer = (state = initialState, action) => {
  switch (action?.type) {
    case FETCH_EXCEL_CATEGORIES:
    case FETCH_EXCEL_INDICATIONS:
    case FETCH_EXCEL_CHART_DATA:
    case FETCH_EXCEL_YEARS:
      return {
        ...state,
        fetchingExcelData: true,
      };
    case FETCH_DATA_CATEGORIES:
      return {
        ...state,
        fetchingDataCategories: true,
      };
    case FETCH_SUB_DATA_CATEGORIES:
      return {
        ...state,
        fetchingSubDataCategories: true,
      };
    case FETCH_DATA_CATEGORY:
      return {
        ...state,
        fetchingSingleCategory: true,
      };
    case FETCH_DATASETS:
      return {
        ...state,
        fetchingDataSets: true,
      };
    case FETCH_DATA_VALUES:
      return {
        ...state,
        fetchingDataValues: true,
      };
    case FETCH_TRENDING_CATEGORIES:
      return {
        ...state,
        fetchingTrendingCategories: true,
      };
    case FETCH_EXCEL_CATEGORIES_COMPLETE:
      return {
        ...state,
        fetchingExcelData: false,
        excelCategories: action.payload,
      };
    case FETCH_EXCEL_INDICATIONS_COMPLETE:
      return {
        ...state,
        fetchingExcelData: false,
        excelIndications: action.payload,
      };
    case FETCH_EXCEL_CHART_DATA_COMPLETE:
      return {
        ...state,
        fetchingExcelData: false,
        excelChartData: action.payload,
      };
    case FETCH_EXCEL_YEARS_COMPLETE:
      return {
        ...state,
        fetchingExcelData: false,
        excelYears: action.payload,
      };
    case FETCH_DATA_CATEGORIES_COMPLETE:
      return {
        ...state,
        fetchingDataCategories: false,
        dataCategories: action.payload,
      };
    case FETCH_SUB_DATA_CATEGORIES_COMPLETE:
      return {
        ...state,
        fetchingSubDataCategories: false,
        subDataCategories: action.payload,
      };
    case FETCH_DATA_CATEGORY_COMPLETE:
      return {
        ...state,
        fetchingSingleCategory: false,
        singleCategory: action.payload,
      };
    case FETCH_DATASETS_COMPLETE:
      return {
        ...state,
        fetchingDataSets: false,
        dataSets: action.payload,
      };
    case FETCH_DATA_VALUES_COMPLETE:
      return {
        ...state,
        fetchingDataValues: false,
        dataValues: action.payload?.data || [],
        totalDataValues: action.payload?.total || 0,
      };
    case FETCH_TRENDING_CATEGORIES_COMPLETE:
      return {
        ...state,
        fetchingTrendingCategories: false,
        trendingCategories: action.payload,
      };
    case ADD_DATA_CATEGORY:


      return {
        ...state,
        addingDataCategory: true,
      };
    case ADD_DATA_CATEGORY_FAILED:
      return {
        ...state,
        addingDataCategory: false,
      };
    case ADD_DATA_CATEGORY_SUCCESS:
      return {
        ...state,
        addingDataCategory: false,
      };
    case ADD_DATASET:
      return {
        ...state,
        addingDataset: true,
      };
    case ADD_DATASET_FAILED:
      return {
        ...state,
        addingDataset: false,
      };
    case ADD_DATASET_SUCCESS:
      return {
        ...state,
        addingDataset: false,
      };
    case UPDATING_DATA_CATEGORY: return {
      ...state,
      updatingCategory: true,
    }
    case UPDATING_DATA_CATEGORY_COMPLETE: return {
      ...state,
      updatingCategory: false,
    }
    case ADD_DATA_SUB_CATEGORY: return {
      ...state,
      addingSubCategory: true,
    }
    case ADD_DATA_SUB_CATEGORY_COMPLETE: return {
      ...state,
      addingSubCategory: false,
    }
    default:
      return state;
  }
};
